// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M12 9.5C13.3807 9.5 14.5 10.6193 14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12C9.5 10.6193 10.6193 9.5 12 9.5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM12.001 3.00195C7.03098 3.00195 3.00114 7.03021 3.00098 12C3.00114 16.9698 7.03098 20.999 12.001 20.999C12.9811 20.999 13.9267 20.8419 14.8125 20.5508L15.7627 20.2383L15.1377 18.3389L14.1885 18.6504C13.5017 18.8761 12.7663 18.999 12.001 18.999C8.13542 18.999 5.00114 15.8651 5.00098 12C5.00114 8.13491 8.13542 5.00195 12.001 5.00195C15.8663 5.00221 18.9998 8.13506 19 12V13.75C19 14.4404 18.4404 15 17.75 15C17.0596 15 16.5 14.4404 16.5 13.75V7.5H14.5V8.25781C13.7849 7.77917 12.9251 7.5 12 7.5C9.51471 7.5 7.5 9.51471 7.5 12C7.5 14.4853 9.51471 16.5 12 16.5C13.1285 16.5 14.1584 16.0827 14.9482 15.3965C15.5132 16.3558 16.5561 17 17.75 17C19.5449 17 21 15.5449 21 13.75V12C20.9998 7.03036 16.9708 3.00221 12.001 3.00195Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-mentioned-filled')
export default class MentionedFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'mentioned-filled',
    }
  }
}
